import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Quanto custa a simulação?",
    a: "Zero. A simulação visual e a estimativa de investimento são totalmente gratuitas, sem compromisso. Só cobramos se decidir avançar, e sempre através do instalador parceiro.",
  },
  {
    q: "Em quanto tempo recebo o resultado?",
    a: "Menos de 24 horas, mesmo aos fins de semana. Se houver pormenores de enquadramento para validar, pedimos uma segunda imagem.",
  },
  {
    q: "Que tipo de foto devo enviar?",
    a: "Uma fotografia ampla do jardim, tirada de pé, em luz natural. Idealmente que mostre os limites do terreno e a fachada da casa, para posicionar a piscina com proporções reais.",
  },
  {
    q: "Como escolhem o instalador?",
    a: "Trabalhamos com uma empresa por zona geográfica: Cascais, Oeiras, Sintra e Lisboa. Fazemos a introdução directa, sem intermediários. O orçamento é negociado entre si e o instalador.",
  },
  {
    q: "E se eu não quiser avançar?",
    a: "Não acontece nada. Fica com a simulação, a estimativa, e a liberdade de decidir quando quiser. Não insistimos, não passamos o seu contacto sem autorização.",
  },
  {
    q: "Os meus dados estão seguros?",
    a: "Sim. Só utilizamos a fotografia para a simulação e o contacto para lhe enviar o resultado. Cumprimos o RGPD e nunca partilhamos dados com terceiros sem consentimento expresso.",
  },
];

export default function FAQ() {
  return (
    <section
      data-testid="faq-section"
      className="border-b border-rule bg-bone"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 py-20 md:py-32 grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-4 reveal">
          <div className="overline text-ink/60">Perguntas frequentes</div>
          <h2 className="font-serif font-light text-4xl md:text-5xl tracking-tight mt-4 leading-[1.05]">
            Tudo o que quer
            <br />
            <span className="italic text-pool-deep">saber antes.</span>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-rule last:border-b-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-ink hover:no-underline py-6 font-normal">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base md:text-lg text-ink/70 font-light leading-relaxed pb-8 pr-10">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
